import { useTranslation } from 'react-i18next'

import { PAYSLIP_LANGS, type PayslipLang } from './payslipLang'

const activeClass =
  'rounded-md bg-slate-900 px-2.5 py-1 text-xs font-medium text-white pointer-coarse:min-h-11 dark:bg-slate-100 dark:text-slate-900 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-focus'
const idleClass =
  'rounded-md px-2.5 py-1 text-xs text-slate-600 hover:bg-slate-50 pointer-coarse:min-h-11 dark:text-slate-300 dark:hover:bg-slate-700/60 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-focus'

/** The EN/MN/RU switch for which language a payslip PDF is printed in. */
export function PayslipLangPicker({ lang, onLang }: { lang: PayslipLang; onLang: (lang: PayslipLang) => void }) {
  const { t } = useTranslation()
  return (
    <div role="radiogroup" aria-label={t('payroll.payslipLanguage')} className="inline-flex shrink-0 rounded-lg border border-border p-0.5">
      {PAYSLIP_LANGS.map((code) => (
        <button
          key={code}
          type="button"
          role="radio"
          aria-checked={lang === code}
          lang={code}
          onClick={() => onLang(code)}
          className={lang === code ? activeClass : idleClass}
        >
          {code.toUpperCase()}
        </button>
      ))}
    </div>
  )
}
